import groupBy from 'lodash/groupBy';
import findKey from 'lodash/findKey';
import toPairs from 'lodash/toPairs';
import update from 'lodash/update';

import pipe from 'lodash/fp/pipe';
import _sumBy from 'lodash/fp/sumBy';
import _groupBy from 'lodash/fp/groupBy';
import _mapValues from 'lodash/fp/mapValues';
import _maxBy from 'lodash/fp/maxBy';
import _get from 'lodash/fp/get';

export const groupCollection = (
  collection,
  mappingOptions,
  otherKey = 'other',
) =>
  groupBy(
    collection,
    c => findKey(mappingOptions, option => option(c)) || otherKey,
  );

export const updateMultiple = (object, updates) =>
  toPairs(updates).reduce(
    (res, [key, transform]) =>
      object[key] ? update(res, key, transform) : res,
    { ...object },
  );

export const groupedSumOf = sumByField => groupByField =>
  pipe(
    _groupBy(groupByField),
    _mapValues(_sumBy(sumByField)),
  );

export const groupAmountSumBy = groupedSumOf('amount');

export const getMax = maxBy =>
  pipe(
    _maxBy(maxBy),
    _get(maxBy),
  );

export const preconcatWith = (...values) => array =>
  [].concat(...values).concat(array);
